// Render a date-only value the way a person reads it.
//
// The trap this exists to avoid: new Date("2026-06-08") parses as UTC
// midnight, and toLocaleDateString then renders it in local time - one day
// earlier anywhere west of Greenwich, which is everywhere Sea Tow operates. A
// stored June 8 displayed as June 7, which is how the auto-renew banner came
// to show a renewal date that had already passed.
//
// Date-only strings are calendar dates, not instants, so they are built from
// their parts in local time and never cross a timezone.
export function formatCalendarDate(raw) {
  if (raw === null || raw === undefined || raw === "") return null;

  const value = String(raw);
  const parts = value.slice(0, 10).split("-");
  const date =
    parts.length === 3
      ? new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]))
      : new Date(value);

  if (Number.isNaN(date.getTime())) return raw;
  return date.toLocaleDateString(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}
